import { Routes } from '@angular/router';
import { Path } from './core/path.enum';
import { MiddlewareComponent } from './components/middleware/middleware.component';
import { NotFoundPage } from './components/not-found/not-found.page';

export const routes: Routes = [
  {
    path: `${Path.MOVIE_DETAIL}/:id`,
    component: MiddlewareComponent,
  },
  {
    path: `${Path.WEB_SERIES}/:id`,
    component: MiddlewareComponent,
  },
  {
    path: '**',
    component: NotFoundPage,
  },
];
